import SvgIcon from "@mui/material/SvgIcon";

const ArrowHeadDown = (props) => (
  <SvgIcon {...props}>
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill="#42526E" fillOpacity="0.86" />
    </svg>
  </SvgIcon>
);

export default ArrowHeadDown;
